<div class="terms-wrapper">
  <div class="container position-relative">
    <a (click)="goBack()" style="cursor: pointer;">
      <img src="assets/images/arrow_left_alt.svg" class="arrow" />
    </a>
    <h1 class="page-title ms-5">Shipping & Delivery Policy</h1>
  </div>

  <p class="body-text">
  BeExpert provides digital services only, not physical products.
  </p>

  <h2 class="section-title">1. Service Delivery</h2>
  <p class="body-text">After successful payment:</p>

  <ul class="body-text">
    <li>Mentor session details are delivered via email/app</li>
    <li>AI Interview results are delivered digitally</li>
    <li>No physical delivery or shipping required</li>
  </ul>

  <h2 class="section-title">2. Delivery Timelines</h2>

  <ul class="body-text">
    <li><strong>Session confirmation:</strong> instantly</li>
    <li>
      <strong>AI interview reports:</strong> instantly or shortly after
      processing
    </li>
  </ul>

  <h2 class="section-title">3. No Physical Shipping</h2>

  <p class="body-text">Since BeExpert is fully digital:</p>

  <ul class="body-text">
    <li>There are no shipping charges</li>
    <li>No delivery partners involved</li>
  </ul>
  <h2 class="section-title">Contact Information</h2>
  <p>
    If you have any questions about service delivery, please contact us at
    <span class="email-value">{{ email }}</span>
  </p>
</div>
